import { STATUS } from 'server/api/lib/response/constants';

/**
 * This file should only contain constants and error classes
 * so it can be imported in the frontend and backend
 */

/**
 * Standard error message text. This helps us keep error messages consistent across the app.
 */
export const ErrorMsg = {
  RESOURCE_ALREADY_EXISTS: 'That resource already exists',
  UNEXPECTED_ERROR: 'An unexpected error occurred',
  PLATFORM_NOT_SUPPORTED: 'Platform not supported',
  COULD_NOT_FIND_OR_CREATE_POST_WITH_URL: 'Could not find or create post with url',
  FAILED_TO_SCRAPE_POST_WITH_URL: 'Failed to scrape post with url',
  FAILED_TO_SCRAPE_POST: 'Failed to scrape post',
  INVALID_URL: 'Invalid url',
  COULD_NOT_FIND_CHANNEL_FOR_USERNAME: 'Could not find a channel for that username',
  INVALID_QUERY: 'Invalid query',
  USER_WAS_NOT_FOUND: 'User was not found',
  CODE_IS_INVALID_OR_EXPIRED: 'Sorry that code is invalid or expired!',
};

export class PermissionError extends Error {
  statusCode: number = STATUS.UNAUTHORIZED;

  constructor(message: string) {
    super(message);
    this.name = 'PermissionError';
  }
}

export class NotFoundError extends Error {
  statusCode: number = STATUS.NOT_FOUND;

  constructor(message: string) {
    super(message);
    this.name = 'NotFoundError';
  }
}

export class TimeoutError extends Error {
  statusCode: number = STATUS.TIMEOUT;

  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}

export class BadRequestError extends Error {
  statusCode: number = STATUS.BAD_REQUEST;

  constructor(message: string) {
    super(message);
    this.name = 'BadRequestError';
  }
}

export class RateLimitError extends Error {
  statusCode: number = STATUS.RATE_LIMIT;

  constructor(message: string) {
    super(message);
    this.name = 'RateLimitError';
  }
}

export class MissingThumbnailError extends Error {
  statusCode: number = STATUS.UNPROCESSABLE_ENTITY;

  constructor(message: string) {
    super(message);
    this.name = 'MissingThumbnailError';
  }
}

export class ForbiddenError extends Error {
  statusCode: number = STATUS.FORBIDDEN;

  constructor(message: string) {
    super(message);
    this.name = 'ForbiddenError';
  }
}

export class UnexpectedError extends Error {
  statusCode: number = STATUS.ERROR;

  constructor(message: string) {
    super(message);
    this.name = 'UnexpectedError';
  }
}

export class FilterUrlError extends Error {
  statusCode: number = STATUS.BAD_REQUEST;

  constructor() {
    super('This filter does not support urls. To import or find a post by url, use the search bar at the top of the screen, or on the homepage.');
    this.name = 'FilterUrlError';
  }
}

export class NetworkPermissionError extends Error {
  statusCode: number = STATUS.UNAUTHORIZED;

  constructor() {
    super('User must be an admin or owner of this social account');
    this.name = 'NetworkPermissionError';
  }
}

export class DeletedPostError extends Error {
  statusCode: number = STATUS.FORBIDDEN;

  constructor() {
    super('This post has been deleted');
    this.name = 'DeletedPostError';
  }
}

export class FeaturedProjectError extends Error {
  statusCode: number = STATUS.FORBIDDEN;

  constructor() {
    super('You are not credited on all of the posts in this project. Please credit yourself on all posts before featuring this project.');
    this.name = 'FeaturedProjectError';
  }
}
